module.exports = __webpack_public_path__ + "static/media/g2g-logo.79b50040.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/g2g-logo.png
// module id = 3700
// module chunks = 0